module.exports = __webpack_public_path__ + "img/arenamain_logo.f819cbd0.png";